export default "__VITE_ASSET__BBENKwlq__"